import React from 'react';
import StringFieldProto from './string-proto.jsx';


export default function renderStringInView(id, props) {
    return <StringFieldProto renderMode="view" id={id} {...props} />;
}